import { render } from "./Terms.vue?vue&type=template&id=7fafa890&scoped=true"
const script = {}

import "./Terms.vue?vue&type=style&index=0&id=7fafa890&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fafa890"]])

export default __exports__